module.exports = __webpack_public_path__ + "img/stock1.9c97e68b.png";